import(/* webpackMode: "eager" */ "/app/app/(home)/profile/page.tsx");
